import { useModalRuleProcessor } from './use-modal-rule-processor';

export const useGenerateAIResponseToAutomationRuleModalFormat = () => {
  const { processGeneratedRule, convertGeneratedRuleToModalFormat } = useModalRuleProcessor();

  return {
    processGeneratedRule,
    convertGeneratedRuleToModalFormat,
  };
};
